import { apiClient } from '../client/apiClient';
import type { IPaginatedResponse, IPagination } from '../types/common';
import type { INews } from '../types/news';

export const newsService = {
	/**
	 * Get trending news
	 */
	getTrendingNews: (category?: string, params?: IPagination) =>
		apiClient.get<IPaginatedResponse<INews>>('/news/trending', {
			params: { ...params, category },
		}),
};
